import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatMarketCap = (marketCap: number): string => {
  if (marketCap === 0) return "$0";
  if (marketCap >= 1000000000)
    return `$${(marketCap / 1000000000).toFixed(1)}B`;
  if (marketCap >= 1000000) return `$${(marketCap / 1000000).toFixed(1)}M`;
  if (marketCap >= 1000) return `$${(marketCap / 1000).toFixed(1)}K`;
  return `$${marketCap}`;
};

export const formatTimeAgo = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) return "today";
  if (diffInDays === 1) return "1d ago";
  return `${diffInDays}d ago`;
};

export const notifyTransactionCompleted = (tokenMint: string) => {
  const timestamp = Date.now().toString();
  localStorage.setItem("transaction_completed", "true");
  localStorage.setItem("last_tx_timestamp", timestamp);

  // Trigger custom event for same-tab communication
  window.dispatchEvent(
    new CustomEvent("transactionCompleted", {
      detail: { timestamp, tokenMint: tokenMint || "" },
    })
  );
};
